module.exports = {versao:  1346 ,
url:"https://sec-stag-api.aplicativogo.com.br"};
